// extracted by mini-css-extract-plugin
module.exports = {"base":"_2-a2pC _2h7kus","description":"_3__JXt"};